import { createFileRoute, redirect, Outlet, useRouterState } from '@tanstack/react-router';
import { AppShell } from '../../components/layouts/AppShell';
import { BrandingProvider } from '../../components/layouts/BrandingProvider';
import { PermissionsBridge } from '../../components/permissions/PermissionsBridge';
import { resolveMfaSetupRedirect, MFA_SETUP_AREA } from '../../lib/authGuard';
import { useAuth } from '../../hooks/useAuth';

function AuthenticatedLayout() {
    const { user } = useAuth();
    const pathname = useRouterState({ select: (s) => s.location.pathname });
    // F-12: durante el setup FORZADO de 2º factor (mfaSetupRequired) la pantalla es STANDALONE —
    // sin el menú lateral/AppShell, igual que la de nueva contraseña. El user todavía no "entró" a
    // la app. Un user normal (mfaSetupRequired=false) ve /me/security/* con el AppShell normal.
    const forcedSetup = !!user?.mfaSetupRequired && pathname.startsWith(MFA_SETUP_AREA);
    return (
        <BrandingProvider>
            <PermissionsBridge>
                {forcedSetup ? (
                    <Outlet />
                ) : (
                    <AppShell>
                        <Outlet />
                    </AppShell>
                )}
            </PermissionsBridge>
        </BrandingProvider>
    );
}

export const Route = createFileRoute('/_authenticated/_layout')({
    beforeLoad: async ({ context, location }) => {
        const state = await context.auth.ensureLoaded();
        if (!state.user) {
            throw redirect({ to: '/login', search: { from: location.pathname } });
        }
        // Gate F-12: sin 2º factor elegido no se entra a la app.
        const mfaRedirect = resolveMfaSetupRedirect(state.user, location.pathname);
        if (mfaRedirect) {
            throw redirect({ to: mfaRedirect });
        }
    },
    component: AuthenticatedLayout,
});
